module.exports = __webpack_public_path__ + "images/ff5541b669d485ab04e0893fd00bc6b9-wood0.jpg";